<voxel-icon *ngIf="!valueFilter" (click)="openList()">seta_baixo</voxel-icon>
<voxel-icon *ngIf="valueFilter" (click)="cleanFilter()">fechar</voxel-icon>